import { render, staticRenderFns } from "./SchoolFacilitiesPage.vue?vue&type=template&id=6ee153c0&scoped=true"
import script from "./SchoolFacilitiesPage.vue?vue&type=script&lang=js"
export * from "./SchoolFacilitiesPage.vue?vue&type=script&lang=js"
import style0 from "./SchoolFacilitiesPage.vue?vue&type=style&index=0&id=6ee153c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee153c0",
  null
  
)

export default component.exports